<template>
  <div class="product-card">
    <router-link :to="`/product/${slug}`" class="card-link">
      <div class="img-wrap">
        <img :src="img" :alt="name" class="product-image" />
      </div>
      <h3 class="product-title">{{ name }}</h3>
    </router-link>

    <p class="product-price">{{ price }} {{ getCurrencySymbol(currency) }}</p>

    <div class="product-actions">
      <router-link :to="`/product/${slug}`" class="btn-dark-full">
        {{ translations.product_card.view_product }}
      </router-link>
    </div>

    <Toast
      v-if="showToast"
      :title="translations.product_card.added"
      :message="`${name} ${translations.product_card.was_added}`"
    />
  </div>
</template>

<script>
import { translations } from '@/locales/lang' 
import Toast from './AppToast.vue'
import eventBus from '@/eventBus.js'

export default {
  name: 'AppProductCard',
  components: { Toast },
  props: ['id', 'slug','img', 'name', 'price', 'currency'], // dodajemy currency
  data() {
    return {
      showToast: false
    }
  },
  computed: {
    translations() {
      return translations.value
    }
  },
  methods: {
    getCurrencySymbol(code) {
      const symbols = { PLN: 'zł', EUR: '€', USD: '$' };
      return symbols[code] || code;
    },
    addToCart() {
      const cart = JSON.parse(localStorage.getItem('cart') || '[]')
      const idx = cart.findIndex(item => item.id === this.id)

      if (idx > -1) {
        cart[idx].quantity++
      } else {
        cart.push({
          id: this.id,
          name: this.name,
          slug : this.slug,
          price: this.price,
          quantity: 1
        })
      }

      localStorage.setItem('cart', JSON.stringify(cart))
      this.showToast = true
      eventBus.emit('cartUpdated')

      setTimeout(() => {
        this.showToast = false
      }, 3000)
    }
  }
}
</script>
